var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "ba97938d-80bd-4fd9-97c7-f57770ddcd52",
    "data-name": "Layer 1",
    width: 30.9982,
    height: 46.2559,
    viewBox: "0 0 30.9982 46.2559",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "orange",
    d: "M12.8335,5.5693,12.08,5.125V6c0,8.2231-3.3921,12.0073-6.9834,16.0137-.707.789-1.4219,1.5864-2.1206,2.4262a11.9674,11.9674,0,0,0-2.898,9.17,13.8679,13.8679,0,0,0,5.4151,9.2412,14.8309,14.8309,0,0,0,5.5708,2.2842,24.1057,24.1057,0,0,1-4.2656,5.4843l.6474.7618a25.8568,25.8568,0,0,0,4.6494-6.05,19.0779,19.0779,0,0,0,9.7285-.8018c4.6963-1.7842,7.7647-5.6514,8.8741-11.1816C33.1445,21.1436,20.082,9.8408,12.8335,5.5693ZM29.7168,33.15c-1.0527,5.251-3.8281,8.7646-8.249,10.4434a17.968,17.968,0,0,1-8.8428.8251c.7588-1.34,1.5121-2.8373,2.231-4.4478l.0268.067,7.2959-2.9219-.3711-.9277L15.373,38.7651c.6528-1.562,1.26-3.2237,1.8-4.9741l6.4608-2.9971-.42-.9062-5.6654,2.628A50.1221,50.1221,0,0,0,19.1,24.8184l-.9922-.1172a49.6605,49.6605,0,0,1-1.6151,7.9014l-4.2364-4.8409-.753.6582,4.6482,5.31c-.4952,1.5862-1.0421,3.1035-1.6311,4.5277l-3.8159-4.3594-.7529.6582,4.128,4.716a51.1185,51.1185,0,0,1-2.4864,4.9686,14.1056,14.1056,0,0,1-5.4976-2.1894,12.8445,12.8445,0,0,1-5.0239-8.5567A10.9889,10.9889,0,0,1,3.7441,25.08c.691-.83,1.3975-1.6187,2.0967-2.3984C9.4341,18.6724,12.835,14.8784,13.0669,6.88,20.2139,11.3257,31.9736,21.897,29.7168,33.15Z",
    transform: "translate(-0.0001 -5.125)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "orange",
    d: "M14.4888,10.166a10.9377,10.9377,0,0,1-1.274,5.815A21.11,21.11,0,0,1,10.28,20.6323l.7129.7012a22.0859,22.0859,0,0,0,3.1162-4.9063,12.0019,12.0019,0,0,0,1.3677-6.4116Z",
    transform: "translate(-0.0001 -5.125)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "orange",
    d: "M7.4312,23.6079l.62.7842a17.4407,17.4407,0,0,0,2.1416-2.1152l-.7647-.6446A16.3138,16.3138,0,0,1,7.4312,23.6079Z",
    transform: "translate(-0.0001 -5.125)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.b187acfb123a507ed7754de0427144bb.svg";
export { ForwardRef as ReactComponent };